import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import Button from './Button';

const ConsentContainer = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(30, 30, 30, 0.95);
  padding: 1.5rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 1.5rem 2rem;
  }
`;

const ConsentText = styled.p`
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  text-align: center;
  max-width: 600px;
  
  @media (min-width: 768px) {
    text-align: left;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  
  @media (min-width: 768px) {
    width: auto;
  }
`;

const CookieConsent: React.FC = () => {
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setShowConsent(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowConsent(false);

        // Inicializa o Facebook Pixel após aceitar os cookies
        if (window.fbq) {
            console.log('Inicializando Facebook Pixel após aceitar cookies...');
            window.fbq('init', '1206177091200862');
            // PageView já é enviado pelo PageTracker no App.tsx
            console.log('Facebook Pixel inicializado após aceitar cookies');
        }
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'false');
        setShowConsent(false);
    };

    return (
        <AnimatePresence>
            {showConsent && (
                <ConsentContainer
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <ConsentText>
                        Utilizamos cookies para melhorar sua experiência e rastrear conversões.
                        Ao continuar navegando, você concorda com nossa política de cookies.
                    </ConsentText>
                    <ButtonGroup>
                        <Button onClick={handleDecline}>
                            Recusar
                        </Button>
                        <Button primary onClick={handleAccept}>
                            Aceitar
                        </Button>
                    </ButtonGroup>
                </ConsentContainer>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent; 